import { render, staticRenderFns } from "./DayNewsFeedItem.vue?vue&type=template&id=3622ad34&"
import script from "./DayNewsFeedItem.vue?vue&type=script&lang=js&"
export * from "./DayNewsFeedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LrGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3622ad34')) {
      api.createRecord('3622ad34', component.options)
    } else {
      api.reload('3622ad34', component.options)
    }
    module.hot.accept("./DayNewsFeedItem.vue?vue&type=template&id=3622ad34&", function () {
      api.rerender('3622ad34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/day-news-feed-item/DayNewsFeedItem.vue"
export default component.exports